export enum roles {
    vat_validation_admin = "vat-validation-admin", // Access to amazon module
    vat_validation_generate = "vat-validation-generate", // Access to generate
    vat_validation_settings = "vat-validation-settings", // Access to settings
}